import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function LoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("admin@ichaitanya.com");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace/>;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, pw);
      nav("/admin");
    } catch(err) { toast.error(formatErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grain-bg flex items-center justify-center p-6" data-testid="admin-login">
      <form onSubmit={submit} className="soft-card max-w-md w-full">
        <div className="font-serif text-3xl text-terracotta">iChaitanya</div>
        <div className="text-xs uppercase tracking-[0.25em] text-[#7E736E] mt-1">Admin Console</div>
        <h1 className="font-serif text-3xl mt-6">Welcome back.</h1>

        <div className="mt-6 space-y-4">
          <div className="space-y-1">
            <Label>Email</Label>
            <Input data-testid="login-email" value={email} onChange={e=>setEmail(e.target.value)} type="email" required/>
          </div>
          <div className="space-y-1">
            <Label>Password</Label>
            <Input data-testid="login-password" value={pw} onChange={e=>setPw(e.target.value)} type="password" required/>
          </div>
        </div>
        <button data-testid="login-submit" disabled={loading} className="btn-primary w-full mt-6">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
